import { createFileRoute } from '@tanstack/react-router'

import { BillingSection } from '@/features/organization/billing-section'
import { useAuth } from '@/hooks/use-auth'

export const Route = createFileRoute('/_app/organizacao/assinatura')({
  component: AssinaturaTab,
})

function AssinaturaTab() {
  const { currentOrgId } = useAuth()
  return <BillingSection orgId={currentOrgId} />
}
